var React = require('react');

function S1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"S1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M218.6,293.11h0a29.23,29.23,0,0,0-3.52-4.24L173.15,330.8a29.65,29.65,0,0,0,45.45-37.69Z","transform":"translate(-173.15 -259.72)","fill":"#e5c83d","key":0}),React.createElement("path",{"d":"M218.6,293.11l8.6-32.39a29.64,29.64,0,0,0-30.93,46.95h0A29.55,29.55,0,0,0,212,318l6.61-24.91Z","transform":"translate(-173.15 -259.72)","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

S1.defaultProps = {"viewBox":"0 0 54.05 79.76"};

module.exports = S1;

S1.default = S1;
